// wp-icons — Craft & WerkPilot-specific (9)
// Handwerks-spezifische Icons, die in Standard-Libraries fehlen oder generisch sind.
import { createWpIcon } from './createIcon.js';

// Wrench — Werkzeug / Reparatur
export const Wrench = createWpIcon('Wrench', [
  ['path', { d: 'M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z', key: 'a' }],
]);

// Hammer — Auftrag / Ausführung
export const Hammer = createWpIcon('Hammer', [
  ['path', { d: 'm15 12-8.373 8.373a1 1 0 1 1-3-3L12 9', key: 'a' }],
  ['path', { d: 'm18 15 4-4', key: 'b' }],
  ['path', { d: 'm21.5 11.5-1.914-1.914A2 2 0 0 1 19 8.172V7l-2.26-2.26a6 6 0 0 0-4.202-1.756L9 2.96l.92.82A6.18 6.18 0 0 1 12 8.4V10l2 2h1.172a2 2 0 0 1 1.414.586L18.5 14.5', key: 'c' }],
]);

// HardHat — Handwerker / Team / Schutzhelm
export const HardHat = createWpIcon('HardHat', [
  ['path', { d: 'M2 18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1z', key: 'a' }],
  ['path', { d: 'M4 15v-3a6 6 0 0 1 6-6', key: 'b' }],
  ['path', { d: 'M14 6a6 6 0 0 1 6 6v3', key: 'c' }],
  ['path', { d: 'M14 6V5a2 2 0 0 0-2-2h0a2 2 0 0 0-2 2v1', key: 'd' }],
  ['path', { d: 'M4 15h16', key: 'e' }],
]);

// Settings / Gear — Einstellungen / Automation
export const Settings = createWpIcon('Settings', [
  ['path', { d: 'M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z', key: 'a' }],
  ['circle', { cx: 12, cy: 12, r: 3, key: 'b' }],
]);

// Cog — alternate gear (simpler)
export const Cog = createWpIcon('Cog', [
  ['path', { d: 'M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z', key: 'a' }],
  ['path', { d: 'M12 14a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z', key: 'b' }],
  ['path', { d: 'M12 2v2', key: 'c' }],
  ['path', { d: 'M12 22v-2', key: 'd' }],
  ['path', { d: 'm17 20.66-1-1.73', key: 'e' }],
  ['path', { d: 'M11 10.27 7 3.34', key: 'f' }],
  ['path', { d: 'm20.66 17-1.73-1', key: 'g' }],
  ['path', { d: 'm3.34 7 1.73 1', key: 'h' }],
  ['path', { d: 'M14 12h8', key: 'i' }],
  ['path', { d: 'M2 12h2', key: 'j' }],
  ['path', { d: 'm20.66 7-1.73 1', key: 'k' }],
  ['path', { d: 'm3.34 17 1.73-1', key: 'l' }],
  ['path', { d: 'm17 3.34-1 1.73', key: 'm' }],
  ['path', { d: 'm11 13.73-4 6.93', key: 'n' }],
]);

// Zap — schnell / Automatisierung
export const Zap = createWpIcon('Zap', [
  ['path', { d: 'M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z', key: 'a' }],
]);

// BarChart3 — Analytics / Umsatz
export const BarChart3 = createWpIcon('BarChart3', [
  ['path', { d: 'M3 3v18h18', key: 'a' }],
  ['path', { d: 'M18 17V9', key: 'b' }],
  ['path', { d: 'M13 17V5', key: 'c' }],
  ['path', { d: 'M8 17v-3', key: 'd' }],
]);

// TrendingUp — Wachstum
export const TrendingUp = createWpIcon('TrendingUp', [
  ['polyline', { points: '22 7 13.5 15.5 8.5 10.5 2 17', key: 'a' }],
  ['polyline', { points: '16 7 22 7 22 13', key: 'b' }],
]);

// PieChart
export const PieChart = createWpIcon('PieChart', [
  ['path', { d: 'M21 12c0 4.97-4.03 9-9 9s-9-4.03-9-9 4.03-9 9-9', key: 'a' }],
  ['path', { d: 'M22 12A10 10 0 0 0 12 2v10z', key: 'b' }],
]);

// Home — Einsatzort
export const Home = createWpIcon('Home', [
  ['path', { d: 'm3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z', key: 'a' }],
  ['polyline', { points: '9 22 9 12 15 12 15 22', key: 'b' }],
]);

// Map — Einsatzgebiet
export const Map = createWpIcon('Map', [
  ['path', { d: 'M14.106 5.553a2 2 0 0 0 1.788 0l3.659-1.83A1 1 0 0 1 21 4.619v12.764a1 1 0 0 1-.553.894l-4.553 2.277a2 2 0 0 1-1.788 0l-4.212-2.106a2 2 0 0 0-1.788 0l-3.659 1.83A1 1 0 0 1 3 19.381V6.618a1 1 0 0 1 .553-.894L8.106 3.44a2 2 0 0 1 1.788 0z', key: 'a' }],
  ['path', { d: 'M15 5.764v15', key: 'b' }],
  ['path', { d: 'M9 3.236v15', key: 'c' }],
]);

// MapPin — Adresse
export const MapPin = createWpIcon('MapPin', [
  ['path', { d: 'M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0', key: 'a' }],
  ['circle', { cx: 12, cy: 10, r: 3, key: 'b' }],
]);

// Navigation — Route
export const Navigation = createWpIcon('Navigation', [
  ['polygon', { points: '3 11 22 2 13 21 11 13 3 11', key: 'a' }],
]);

// Plug — Integration
export const Plug = createWpIcon('Plug', [
  ['path', { d: 'M12 22v-5', key: 'a' }],
  ['path', { d: 'M9 8V2', key: 'b' }],
  ['path', { d: 'M15 8V2', key: 'c' }],
  ['path', { d: 'M18 8v5a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4V8Z', key: 'd' }],
]);

// ClipboardCheck — Checkliste
export const ClipboardCheck = createWpIcon('ClipboardCheck', [
  ['rect', { width: 8, height: 4, x: 8, y: 2, rx: 1, ry: 1, key: 'a' }],
  ['path', { d: 'M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2', key: 'b' }],
  ['path', { d: 'm9 14 2 2 4-4', key: 'c' }],
]);
